import { call, put, takeLatest } from 'redux-saga/effects';
import { AdminCompetences } from 'services/api';
import {
  getAdminCompetences,
  getAdminCompetencesSuccess,
  getAdminCompetencesFailure,
} from '../../actions';
import { actions as notificationActions } from 'components/Notification';

function* getAdminCompetencesSaga(params) {
  try {
    const { data } = yield call(
      AdminCompetences.getCompetences,
      params.payload
    );
    yield put(getAdminCompetencesSuccess(data));
  } catch (e) {
    yield put(getAdminCompetencesFailure(e.data));
    yield put(
      notificationActions.addNotification(
        e.data.errors.map(error => ({ type: 'error', message: error.code }))
      )
    );
  }
}

export default () => takeLatest(getAdminCompetences, getAdminCompetencesSaga);
